import Cookies, { CookieGetOptions, CookieSetOptions } from 'universal-cookie';

const cookies = new Cookies();

export const setCookie = (name: string, value: string, option?: CookieSetOptions) => {
	return new Cookies().set(name, value, { ...option });
};

export const getCookie = (name: string) => {
	return new Cookies().get(name);
};

export const removeCookie = (name: string, option?: CookieSetOptions) => {
	return cookies.remove(name, { ...option });
};

export const getContextCookie = (context: any) => {
	if (!context || !context.req.headers.cookie) return '';
	const cookie = context.req.headers.cookie.split(';');

	const _token = cookie.find((item: string) => item.includes('uplus_access_token'));

	const token = _token ? _token.split('=')[1] : '';

	return token;
};
